import { render, staticRenderFns } from "./entRecord.vue?vue&type=template&id=035b57d3&scoped=true&"
import script from "./entRecord.vue?vue&type=script&lang=js&"
export * from "./entRecord.vue?vue&type=script&lang=js&"
import style0 from "./entRecord.vue?vue&type=style&index=0&lang=css&"
import style1 from "./entRecord.vue?vue&type=style&index=1&id=035b57d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b57d3",
  null
  
)

export default component.exports